import * as React from 'react';
import IntersectionObserver from 'react-intersection-observer';
import {withI18n, WithI18nProps} from '@shopify/react-i18n';
import {Section, Banner, Text, NOOP} from 'components/UIKit';
import * as locales from '../../locales';
import {ListingMetric as ListingMetricType, ListingChartDescriptor} from '../../types';
import {ListingMetric} from '../ListingMetrics';
import {ListingChart} from '../ListingChart';
import styles from './ListingTrafficPerf.scss';

export interface ListingTrafficPerfProps {
  id?: string;
  charts: ListingChartDescriptor[];
  metrics: ListingMetricType[];
  profitDetails?: string;
  onVisibilityChange?: any;
}

class ListingTrafficPerfComponent extends React.Component<ListingTrafficPerfProps & WithI18nProps> {
  handleViewportChange = (inView) => {
    const {onVisibilityChange = NOOP, id} = this.props;

    onVisibilityChange(id, inView);
  };

  shouldComponentUpdate() {
    return false;
  }

  render() {
    const {id, i18n, charts = [], metrics = [], profitDetails} = this.props;

    const showProfitDetails = Boolean(profitDetails);

    return (
      <IntersectionObserver threshold={0.3} rootMargin="-72px" onChange={this.handleViewportChange}>
        <Section
          id={id}
          spacing="medium"
          heading={i18n.translate('trafficPerf')}
          headingProps={{type: 'h5', component: 'h2'}}
          fullWidth
        >
          <ul className={styles.List}>
            {metrics.map((metric) => (
              <ListingMetric key={metric.title} metric={metric} showVerified />
            ))}
          </ul>
          {showProfitDetails && (
            <div className={styles.ProfitDetails}>
              <Banner display="sparse" icon="alertTriangle" iconSize={20}>
                <Text resetMargin secondary text={i18n.translate('profitDetails')} />
                &nbsp;
                <Text resetMargin text={profitDetails} />
              </Banner>
            </div>
          )}
          {charts.map((chart) => (
            <div key={chart.type} className={styles.Chart}>
              <ListingChart key={chart.type} id={chart.type} {...chart} />
              <Banner richIcon="shopify" display="shopify" className={styles.ChartBanner}>
                {i18n.translate('verifiedBanner', {
                  type: i18n.translate(chart.type),
                })}
              </Banner>
            </div>
          ))}
        </Section>
      </IntersectionObserver>
    );
  }
}

export const ListingTrafficPerf = withI18n({
  id: 'Listing',
  fallback: locales.en,
})(ListingTrafficPerfComponent);

export default ListingTrafficPerf;
